import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section id="categories" className="w-full py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            Product Categories
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Explore All <span className="text-accent-500">Spreadsheet Categories</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Browse our complete collection of organized product categories — each powered by detailed spreadsheet research, price comparisons, and buyer insights
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 max-w-7xl mx-auto">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} spreadsheet category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent"></div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <div className="flex items-center justify-between mb-1.5">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                    {cat.name}
                  </h3>
                  <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-400 text-sm transition-colors duration-200"></i>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed flex-1">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}